<template>
  <head>
    <meta charset="utf-8" />
    <title>County Biller</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- Bootstrap CSS -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons CSS -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App CSS-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- Custom CSS-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- Add Font Awesome for better icons -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

  </head>

  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page title and breadcrumbs -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="d-sm-flex align-items-center justify-content-between">
                <div>
                  <h3 class="page-title mb-1">County Biller Auto Reconciliation</h3>
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                      <li class="breadcrumb-item"><a href="dashboard.html"><i class="fas fa-home"></i> Dashboard</a></li>
                      <li class="breadcrumb-item active">Auto Reconciliation</li>
                    </ol>
                  </nav>
                </div>
                <div class="mt-3 mt-sm-0">
                  <!-- You could add buttons here if needed -->
                </div>
              </div>
            </div>
          </div>

          <!-- Main content card -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <div>
                    <h5 class="card-title mb-0">
                      <i class="fas fa-history me-2"></i> Reconciliations History
                    </h5>
                  </div>
                  <div class="d-flex align-items-center">
                    <!-- Export button group - NEW FEATURE -->
                    <div class="btn-group me-4" v-if="ReconTransactions.length > 0">
                      <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-download me-1"></i> Export <i class="fas fa-chevron-down ms-1"></i>
                      </button>
                      <ul class="dropdown-menu">
                        <li><a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportToPDF()"><i class="fas fa-file-pdf me-2 text-danger"></i>PDF</a></li>
                        <li><a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportToExcel()"><i class="fas fa-file-excel me-2 text-success"></i>Excel</a></li>
                        <li><a class="dropdown-item" href="javascript: void(0);" @click.prevent="exportToCSV()"><i class="fas fa-file-csv me-2 text-primary"></i>CSV</a></li>
                      </ul>
                    </div>
                    <!-- Date filter -->
                    <div class="date-range-container">
                      <span class="me-2"><i class="far fa-calendar-alt"></i></span>
                      <span class="fw-medium me-3">Filter by date:</span>
                      <input class="form-control me-2" placeholder="From" type="date">
                      <span class="mx-2">to</span>
                      <input class="form-control" placeholder="To" type="date">
                      <button class="btn btn-sm btn-primary ms-3">
                        <i class="fas fa-filter me-1"></i> Apply
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-hover" id="transactions-table">
                      <thead>
                      <tr>
                        <th scope="col"><i class="far fa-calendar-alt me-1"></i> Date</th>
                        <th scope="col"><i class="far fa-file-alt me-1"></i> Description</th>
                        <th class="text-end"><i class="fas fa-money-bill-wave me-1"></i> Amount</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in ReconTransactions">
                        <td>
                          {{item.date}}
                        </td>
                        <th>
                          <p v-if="item.available ==='1'" class="unreconciled mb-0">
                            <i class="fas fa-circle me-1 font-size-10"></i> {{item.description}}
                          </p>
                          <p v-if="item.available ==='0'" class="reconciled mb-0">
                            <i class="fas fa-check-circle me-1 font-size-10"></i> {{item.description}}
                          </p>
                        </th>
                        <td class="text-end fw-medium">KES {{formatPrice(item.amount)}}</td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading state -->
                    <div v-if="loading" class="loading-container">
                      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <h5 class="mt-3">Loading Data</h5>
                      <p class="text-muted col-md-6 mx-auto">
                        We are fetching your reconciliation data. This will only take a moment. Thank you for your patience.
                      </p>
                    </div>

                    <!-- No results state -->
                    <div v-if="ReconTransactions.length < 1 && loading === false" class="no-results-container">
                      <img src="/assets/images/no-results.png" class="img mb-4" alt="No search results"/>
                      <h4>No Reconciliation Data Found</h4>
                      <p class="text-muted col-md-6 mx-auto">
                        We couldn't find any reconciliation records that match your criteria. Try uploading a new statement or adjusting your search filters.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Upload File Modal -->
      <div class="modal fade" id="uploadFile" tabindex="-1" aria-labelledby="uploadFileLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="uploadFileLabel">
                <i class="fas fa-file-upload me-2"></i> Upload Transactions File
              </h5>
              <button @click="closeModal" type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body" v-if="!loading">
              <div class="mb-4">
                <label class="form-label fw-medium">Date Range</label>
                <div class="row">
                  <div class="col-6">
                    <div class="mb-3">
                      <label class="form-label small text-muted">From</label>
                      <input v-model="dateFrom" class="form-control" type="date">
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="mb-3">
                      <label class="form-label small text-muted">To</label>
                      <input v-model="dateTo" class="form-control" type="date">
                    </div>
                  </div>
                </div>
              </div>

              <div class="mb-4">
                <label class="form-label fw-medium">Statement Source</label>
                <select class="form-select" v-model="statement">
                  <option value="" disabled selected>Select statement source</option>
                  <option value="MPESA">M-PESA Transactions</option>
                  <option value="KCB">KCB Bank Transactions</option>
                </select>
              </div>

              <div class="custom-file-input" @click="$refs.fileInput.click()">
                <input
                    ref="fileInput"
                    type="file"
                    class="d-none"
                    @change="handleFileChange($event)"
                />
                <i class="fas fa-cloud-upload-alt"></i>
                <h5 class="upload-text mt-2">Drop file here or click to browse</h5>
                <p class="text-muted small mb-0">Supported formats: CSV, XLS, XLSX</p>
              </div>

              <div v-if="selectedFile" class="alert alert-info mt-3">
                <i class="fas fa-file-alt me-2"></i> Selected file: <strong>{{ selectedFile.name }}</strong>
              </div>

              <!-- Alert messages -->
              <div v-if="message != null" class="mt-3">
                <div v-if="alert.success" class="alert alert-success">
                  <i class="fas fa-check-circle me-2"></i> Reconciliation Complete
                  <hr class="my-2">
                  <p class="mb-0">{{message}}</p>
                </div>
              </div>
            </div>

            <!-- Loading state in modal -->
            <div v-if="loading" class="modal-body py-5">
              <div class="text-center">
                <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h5>Processing Your File</h5>
                <p class="text-muted small">This may take a moment. Please don't close this window.</p>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-light" @click="closeModal">Cancel</button>
              <button @click="uploadExcelToQue()" class="btn btn-primary" :disabled="!selectedFile || loading">
                <i class="fas fa-check me-1"></i> Upload & Reconcile
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              <span class="text-muted">© 2025 NTSA</span>
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                <span class="text-muted">Best Birdy Billing System</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import {paysol, execute, execute2, biller} from "@/api";
import moment from "moment/moment";

export default {
  name: "autoReconciliation",
  components: {NavigationBar},
  data() {
    return {
      dateTo: '',
      dateFrom: '',
      statement: '',
      message: null,
      loading: false,
      selectedFile: null,
      alert: {
        success: false,
        info: false,
        failed: false
      },
      ReconTransactions: []
    };
  },
  mounted() {
    this.getReconciledRecords();
    this.menuAccess();
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed to avoid memory leaks
    clearInterval(this.intervalId);
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Recon Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Success handling
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    formatDateTime(dateTimeStr) {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const date = new Date(dateTimeStr);

      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // Handle midnight (00:00) as 12 AM

      return `${day} ${month} ${year} at ${hours}:${minutes.toString().padStart(2, '0')} ${period}`;
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    closeModal() {
      $('#uploadFile').modal('hide');
      // Reset form data when modal is closed
      this.selectedFile = null;
      this.message = null;
      this.alert.success = false;
      this.alert.failed = false;
      this.alert.info = false;
    },

    getReconciledRecords() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getReconciledRecords");
      data.append("reconCode", sessionStorage.getItem("reconCode"));

      execute2(data, paysol)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.ReconTransactions = res.data.data.ReconTransactions;
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error fetching reconciliation records:", e);
          });
    },

    getFileName(filePath) {
      const parts = filePath.split('/');
      return parts[parts.length - 1];
    },

    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },

    uploadExcelToQue() {
      if (!this.selectedFile || !this.statement || !this.dateFrom || !this.dateTo) {
        this.message = "Please fill all required fields and select a file";
        this.alert.failed = true;
        return;
      }

      this.loading = true;

      // Here you would implement the file upload logic
      // For demonstration purposes, we'll simulate a successful upload
      setTimeout(() => {
        this.loading = false;
        this.message = "Successfully reconciled all transactions";
        this.alert.success = true;

        // After successful upload, refresh the records
        this.getReconciledRecords();
      }, 2000);
    },

    formattedTime(time) {
      return moment(time).format('hh:mm A');
    },

    // EXPORT METHODS - NEW FUNCTIONALITY

    // Method to prepare data for export
    prepareExportData() {
      return this.ReconTransactions.map(item => {
        return {
          'Date': item.date,
          'Description': item.description,
          'Status': item.available === '0' ? 'Reconciled' : 'Unreconciled',
          'Amount (KES)': this.formatPrice(item.amount)
        };
      });
    },

    // Get current date formatted for reports
    getFormattedCurrentDate() {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // Export to PDF
    exportToPDF() {
      // Import jsPDF from window object
      const { jsPDF } = window.jspdf;

      // Create new PDF document
      const doc = new jsPDF();

      // Add title and header
      doc.setFontSize(18);
      doc.setTextColor(44, 62, 80);
      doc.text('County Biller Auto Reconciliation', 14, 22);

      // Add date and metadata
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.text(`Generated on: ${this.getFormattedCurrentDate()}`, 14, 30);

      // Add summary if needed
      const totalReconciled = this.ReconTransactions.filter(item => item.available === '0').length;
      const totalUnreconciled = this.ReconTransactions.filter(item => item.available === '1').length;
      doc.text(`Total Records: ${this.ReconTransactions.length} (${totalReconciled} reconciled, ${totalUnreconciled} unreconciled)`, 14, 36);

      // Create table data
      const tableColumn = ["Date", "Description", "Status", "Amount (KES)"];
      const tableRows = [];

      // Fill table data
      this.ReconTransactions.forEach(item => {
        const status = item.available === '0' ? 'Reconciled' : 'Unreconciled';
        const rowData = [
          item.date,
          item.description,
          status,
          `KES ${this.formatPrice(item.amount)}`
        ];
        tableRows.push(rowData);
      });

      // Generate table with auto-table plugin
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 42,
        styles: {
          fontSize: 9,
          cellPadding: 3,
          lineColor: [0, 0, 0]
        },
        headStyles: {
          fillColor: [52, 152, 219],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        },
        alternateRowStyles: {
          fillColor: [245, 247, 250]
        },
        // Add custom styles to specific columns
        columnStyles: {
          0: { cellWidth: 30 }, // Date
          1: { cellWidth: 'auto' }, // Description
          2: { cellWidth: 30 }, // Status
          3: { cellWidth: 30, halign: 'right' } // Amount
        },
        // Style specific cells based on data
        didDrawCell: (data) => {
          // Style for reconciled/unreconciled status
          if (data.section === 'body' && data.column.index === 2) {
            if (data.cell.raw === 'Reconciled') {
              doc.setTextColor(39, 174, 96); // Green color
            } else {
              doc.setTextColor(41, 128, 185); // Blue color
            }
          }
        }
      });

      // Add footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text('County Biller System - Auto Reconciliation Report', 14, doc.internal.pageSize.height - 10);
        doc.text(`Page ${i} of ${pageCount}`, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10);
      }

      // Save the PDF
      doc.save('Reconciliation_Report.pdf');
    },

    // Export to Excel
    exportToExcel() {
      // Prepare data
      const data = this.prepareExportData();

      // Convert to worksheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Create workbook and append worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Reconciliation');

      // Set column widths
      const wscols = [
        { width: 15 }, // Date
        { width: 40 }, // Description
        { width: 15 }, // Status
        { width: 20 }  // Amount
      ];
      worksheet['!cols'] = wscols;

      // Add metadata
      workbook.Props = {
        Title: "Reconciliation Data",
        Subject: "Auto Reconciliation",
        Author: "Billing System",
        CreatedDate: new Date()
      };

      // Generate Excel file and trigger download
      XLSX.writeFile(workbook, 'Reconciliation_Data.xlsx');
    },

    // Export to CSV
    exportToCSV() {
      // Prepare data
      const data = this.prepareExportData();

      // Convert JSON to CSV
      let csv = this.jsonToCSV(data);

      // Create download link
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      // Create temporary link element and trigger download
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'Reconciliation_Data.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // Helper method to convert JSON to CSV
    jsonToCSV(data) {
      if (data.length === 0) return '';

      const replacer = (key, value) => value === null ? '' : value;
      const header = Object.keys(data[0]);

      // Create CSV rows from data
      let csv = data.map(row =>
          header.map(fieldName =>
              JSON.stringify(row[fieldName], replacer))
              .join(',')
      );

      // Add header row
      csv.unshift(header.join(','));

      // Return CSV string
      return csv.join('\r\n');
    }
  },
};
</script>

<style scoped>
/* Custom styles for better UX */
body {
  background-color: #f5f7fb;
  color: #333;
}

.card {
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  margin-bottom: 24px;
}

.card-header {
  background-color: white;
  padding: 20px;
  border-radius: 10px 10px 0 0 !important;
}

.page-title {
  font-weight: 600;
  color: #2c3e50;
}

.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
  padding: 10px 20px;
  border-radius: 6px;
  transition: all 0.3s;
}

.btn-primary:hover {
  background-color: #2980b9;
  border-color: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-dark {
  background-color: #34495e;
  border-color: #34495e;
  padding: 10px 20px;
  border-radius: 6px;
  transition: all 0.3s;
}

.btn-dark:hover {
  background-color: #2c3e50;
  border-color: #2c3e50;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table {
  border-radius: 10px;
  overflow: hidden;
  border-collapse: separate;
  border-spacing: 0;
}

.table thead th {
  background-color: #3498db;
  color: white;
  padding: 15px;
  font-weight: 500;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}

.table tbody td, .table tbody th {
  padding: 15px;
  vertical-align: middle;
}

.no-results-container {
  padding: 40px 20px;
  text-align: center;
}

.no-results-container img {
  max-width: 200px;
  margin-bottom: 20px;
}

.loading-container {
  padding: 40px 20px;
  text-align: center;
}

.custom-file-input {
  position: relative;
  padding: 20px;
  border: 2px dashed #ccc;
  border-radius: 10px;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
  background-color: #f8f9fa;
  margin-top: 15px;
}

.custom-file-input:hover {
  border-color: #3498db;
  background-color: #f0f5ff;
}

.custom-file-input i {
  font-size: 40px;
  color: #3498db;
  margin-bottom: 10px;
}

.upload-text {
  font-weight: 500;
  color: #2c3e50;
}

.date-selector {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.date-selector input {
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
}

.date-selector label {
  margin-right: 10px;
  font-weight: 500;
}

.date-range-container {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 10px 15px;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  margin-bottom: 20px;
}

.status-success {
  color: #27ae60;
}

.status-pending {
  color: #2980b9;
}

.modal-content {
  border-radius: 10px;
  border: none;
}

.modal-header {
  background-color: #f8f9fa;
  border-radius: 10px 10px 0 0;
  padding: 15px 20px;
}

.modal-body {
  padding: 20px;
}

.alert {
  border-radius: 6px;
  padding: 15px;
}

.breadcrumb-item a {
  color: #3498db;
}

.breadcrumb-item.active {
  color: #7f8c8d;
}

.reconciled {
  color: #27ae60;
  font-weight: 500;
}

.unreconciled {
  color: #2980b9;
  font-weight: 500;
}

/* Styles for export dropdown */
.dropdown-menu {
  border-radius: 8px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
}

.dropdown-item {
  padding: 8px 20px;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-item i {
  width: 20px;
}
</style>